import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.75 9.81a4.65 4.65 0 0 1-4.65 4.65H3A.75.75 0 0 1 3 13h7.1a3.15 3.15 0 1 0 0-6.29H3.56L6 9.5a.75.75 0 0 1-.08 1.06.74.74 0 0 1-1-.08l-3.43-4a.71.71 0 0 1-.17-.41.37.37 0 0 1 0-.11.8.8 0 0 1 .18-.46l.19-.22L4.86 1.5A.75.75 0 1 1 6 2.48L3.68 5.17h6.42a4.65 4.65 0 0 1 4.65 4.64ZM1.25 5.92a.43.43 0 0 1 .05-.16 1.17 1.17 0 0 0-.05.2ZM1.43 5.5a.94.94 0 0 0-.12.22.68.68 0 0 1 .31-.44ZM1.31 5.72s-.01.01 0 0Z';
const draw24px =
  'M19.77,13.69A5.75,5.75,0,0,1,14,19.43H6.43a.75.75,0,0,1,0-1.5H14a4.24,4.24,0,0,0,0-8.48H6.6l1.82,2.12a.75.75,0,0,1-.57,1.24.76.76,0,0,1-.57-.26L4.4,9.18a.74.74,0,0,1,0-1L7.28,4.84a.76.76,0,0,1,1.06-.08.75.75,0,0,1,.08,1.06L6.6,8H14A5.74,5.74,0,0,1,19.77,13.69Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const UndoIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'undo'),
) as IconWithRender;

UndoIcon.displayName = 'UndoIcon';
UndoIcon.propTypes = Icon.propTypes;
UndoIcon.renderIcon = (props) => <UndoIcon {...props} />;
export default UndoIcon;
